import { AllActions } from "../actions";
import { StoreState } from "../types";
import * as constants from "../constants";
export function query(
  state: StoreState.Query,
  action: AllActions,
): StoreState.Query {
  if (state === undefined) {
    state = {
      filters: {},
      sort: { sortField: "", sortOrder: "" },
      fixedDisplayFields: [],
      displayFields: [],
      urls: {
        apiJson: null,
        csvDownload: null,
        browserPath: "",
      },
    };
  }
  switch (action.type) {
    case constants.UPDATE_FILTER:
      var updateFilters: any = { ...state.filters };
      updateFilters[action.filterField] = action.filterValue;
      return { ...state, filters: updateFilters };
    case constants.RESET_STATE:
      var resetState = action.newState;
      return { ...resetState };
    case constants.ADD_TO_MULTI_FILTER:
      var addedFilters = state.filters;
      addedFilters[action.filterField] = [
        ...state.filters[action.filterField],
        ...action.filterValues,
      ].filter((val, id, array) => array.indexOf(val) === id);
      return { ...state, filters: addedFilters };
    case constants.REMOVE_FROM_MULTI_FILTER:
      const currentValues = state.filters[action.filterField] || [];
      var updatedFilters = state.filters;
      updatedFilters[action.filterField] = currentValues.filter(
        (element: any) => {
          return action.filterValues.indexOf(element) === -1;
        },
      );
      return { ...state, filters: updatedFilters };
    case constants.ADD_DISPLAY_FIELD:
      let addDisplayFields;
      if (action.clearAll) {
        addDisplayFields = action.newDisplayFields;
      } else {
        addDisplayFields = [
          ...state.displayFields,
          ...action.newDisplayFields,
        ].filter((val, id, array) => array.indexOf(val) === id);
      }
      return { ...state, displayFields: addDisplayFields };
    case constants.REMOVE_DISPLAY_FIELD:
      const filteredDisplayFields = state.displayFields.filter(element => {
        return action.removedFields.indexOf(element) === -1;
      });
      return { ...state, displayFields: filteredDisplayFields };
    case constants.UPDATE_SORT:
      const sort = {
        sortField: action.newSortField,
        sortOrder: action.newSortOrder,
      };
      return { ...state, sort };
    case constants.UPDATE_AGG_REPORT:
      return { ...state, aggReport: action.aggReport };
    case constants.UPDATE_API_URLS:
      return {
        ...state,
        urls: {
          ...state.urls,
          apiJson: action.apiJson,
          csvDownload: action.csvDownload,
        },
      };
    case constants.UPDATE_BROWSER_LOCATION:
      return {
        ...state,
        urls: {
          ...state.urls,
          browserPath: action.locationSearchString,
        },
      };
    default:
      return state;
  }
}
